/**
 * Created by Kieran on 18/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let LessonsApi = {

  /**
   * @returns {AxiosPromise}
   */
  getLessonsList() {
    return axios.get(config.apiUrl + 'lessons/list/')
  },

  /**
   *
   * @param permalink
   * @returns {AxiosPromise}
   */
  getLessonByPermalink(permalink) {
    return axios.get(config.apiUrl + 'lessons/' + permalink)
  },
  /**
   *
   * @param bonudId
   */
  getBonusModule(bonusId) {
    return axios.get(config.apiUrl + 'lessons/bonus/' + bonusId)
  },
  /**
   *
   * @param id
   * @returns {AxiosPromise}
   */
  getPersonalizedContentForLesson(id) {
    return axios.get(config.apiUrl + 'lessons/personalize/' + id);
  },
  /**
   *
   * @param id
   * @returns {AxiosPromise}
   */
  getDownloadsByCourseId(id) {
    return axios.get(config.apiUrl + 'lesson/downloads/' + id)
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  saveDownloadCount(model) {
    return axios.post(config.apiUrl + 'lesson/downloads/count/', model);
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  saveQuizResult(model) {
    return axios.post(config.apiUrl + 'lesson/quiz/results/', model);
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  saveLessonEndRating(model) {
    return axios.post(config.apiUrl + 'lesson/rating/end/', model);
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  saveLessonStartRating(model) {
    return axios.post(config.apiUrl + 'lesson/rating/start/', model);
  }
};

export default LessonsApi;



// WEBPACK FOOTER //
// ./src/api/Lessons/index.js